import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { SessionVerificarInterceptor } from './interceptors/session-verificar.interceptor';
import { NavbarComponent } from './shared/components/navbar/navbar.component';
import { FooterComponent } from './shared/components/footer/footer.component';
import { CallbackComponent } from './components/auth/callback/callback.component';
import { HomeComponent } from './components/home/home.component';
import { OAuthModule } from 'angular-oauth2-oidc';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RutFormatDirective } from './shared/directives/rut-format.directive';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SidebarComponent } from './shared/components/sidebar/sidebar.component';
import { ModalComponent } from './shared/components/modal/modal.component';
import { LoadingComponent } from './shared/components/loading/loading.component';
import { ButtonComponent } from './shared/components/button/button.component';
import { SharedModule } from './shared/shared.module';
import { HeaderExpedienteComponent } from './shared/components/header/expediente/header-expediente.component';
import { HeaderLicenciaComponent } from './shared/components/header/licencia/header-licencia.component';
import { UploadDocumentComponent } from './shared/components/documentos/upload/upload.component';
import { PreviewDocumentComponent } from './shared/components/documentos/preview/preview.component';
import { TemplateDocumentComponent } from './shared/components/documentos/template/template.component';
import { CambioPerfilComponent } from './shared/components/select/cambio-perfil/cambio-perfil.component';
import { BreadcrumbComponent } from './shared/components/breadcrumb/breadcrumb.component';
import { ContainerComponent } from './shared/components/container/container.component';
import { LandingComponent } from '@components/landing/landing.component';
import { AdministracionComponent } from './components/administracion/administracion.component';
import { DictamenMedicoComponent } from './components/administracion/dictamen-medico/dictamen-medico.component';
import { DictamenListadoComponent } from './components/administracion/dictamen-listado/dictamen-listado.component';
import { CasoDictamenComponent } from './components/administracion/caso-dictamen/caso-dictamen.component';
import { CierreAdministrativoComponent } from './components/administracion/cierre-administrativo/cierre-administrativo.component';
import { TrazabilidadComponent } from './components/expedientes-trazabilidad/trazabilidad.component';
import { ReportesAnaliticasComponent } from './components/reportes-analiticas/reportes-analiticas.component';
import { SolicitudSaludIrrecuperableComponent } from './components/solicitud-salud-irrecuperable/solicitud-salud-irrecuperable.component';
import { PresentacionInicialComponent } from './components/presentacion-inicial/presentacion-inicial.component';
import { ApelacionDocumentosComponent } from './components/apelacion-documentos/apelacion-documentos.component';

@NgModule({
  declarations: [
    LandingComponent,
    AppComponent,
    NavbarComponent,
    FooterComponent,
    CallbackComponent,
    HomeComponent,
    RutFormatDirective,
    SidebarComponent,
    ModalComponent,
    LoadingComponent,
    ButtonComponent,
    HeaderExpedienteComponent,
    HeaderLicenciaComponent,
    UploadDocumentComponent,
    PreviewDocumentComponent,
    TemplateDocumentComponent,
    CambioPerfilComponent,
    BreadcrumbComponent,
    ContainerComponent,
    AdministracionComponent,
    DictamenListadoComponent,
    DictamenMedicoComponent,
    CasoDictamenComponent,
    CierreAdministrativoComponent,
    TrazabilidadComponent,
    ReportesAnaliticasComponent,
    SolicitudSaludIrrecuperableComponent,
    PresentacionInicialComponent,
    ApelacionDocumentosComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    RouterModule,
    HttpClientModule,
    OAuthModule.forRoot(),
    FormsModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'custom-toast-container',
      maxOpened: 1,
      autoDismiss: true,
      preventDuplicates: true
    }),
    ReactiveFormsModule,
    SharedModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: SessionVerificarInterceptor, multi: true },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
